import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../../css/entry.css";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js"
import TokenService from "../../service/TokenService";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

import dayjs from "dayjs";

import SriyanshCardHeader from "../../components/CardHeader";
import EncryptService from "../../service/EncryptionService";
import ListHeaderTableComponent from "../../CustomComponant/ListHeaderTables";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
function AccountPendingEntry() {
  const navigate = useNavigate();
  const { state } = useLocation();

  let poNumberFromList = state.expponumber;
  let billNumberFromList = state.expbillnumber;
  
  const [returnData, setreturnData] = useState([]);
  const today = dayjs();
  const [crnNumber, setcrnNumber] = useState();
  const [crnDate, setcrnDate] = useState(null);
  //const [error, setError] = useState("");
  const [accountEntryDate, setaccountEntryDate] = useState(null);
  const handleClose = () => {
    navigate("../accountpendiglist", { replace: true });
  };

  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  // const [CRNGdateerror, setCRNdateerror] = useState("");
  // const [SentToAccountdateerror, setSentToAccountdateerror] = useState("");

  const [errors, setErrors] = useState({});

  const InsertPOData = async (e) => {
    e.preventDefault();

    let formErrors = {};

   // if (CRNGdateerror) formErrors.crnDateerror = "Invalid CRN Date";
    //if (SentToAccountdateerror)
    //  formErrors.sentdateerror = "Invalid Bill Sent Date";

    if (!crnDate) {formErrors.crnDateerror = "Invalid CRN Date";} 
    if (!accountEntryDate) {formErrors.sentdateerror = "Invalid Sent to Account Date";} 





    if (!crnNumber || crnNumber.length === 0)
      formErrors.errCRN = "Invalid CRN Number";

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const crndt = new Date(crnDate);
      const CRNDAT =
        crndt.getFullYear() +
        "/" +
        parseInt(crndt.getMonth() + 1) +
        "/" +
        crndt.getDate();

      const billsentdt = new Date(accountEntryDate);
      const SENTDAT =
        billsentdt.getFullYear() +
        "/" +
        parseInt(billsentdt.getMonth() + 1) +
        "/" +
        billsentdt.getDate();

      apiClient.post("/AccountEntry", {
          vponumber: poNumberFromList,
          vbillnumber: billNumberFromList,
          vcrnnumber: crnNumber,
          vcrndate: CRNDAT,
          vbillsenttoaccountdate: SENTDAT,
          ventryuser: uname,
          vip: ip,
        })
        .then(function (response) {
         // setError(response.data);
          navigate("../accountpendiglist", { replace: true });
        })
        .catch(function (error) {
          if (error.response.data && error.response.data.code==='ER_DUP_ENTRY') {
          alert("Duplicate CRN Not Allowed");
       }
     });
    }
  };

  const getdata = async (e) => {
    apiClient.post("/podetailscrn", {
        uname: uname,
        poNumber: poNumberFromList + " ",
        billnumber: billNumberFromList + " ",
      })
      .then(function (response) {
        setreturnData(response.data[0]);
        //console.log(response.data[0]);
      })
      .catch(function (error) {
       // setError(error);
       alert(error);
      });
  };

  useEffect(() => {
    getdata();
  },[]);

  const headers = [
    ["Indent Number", "PO Number", "Consignee"],
    ["Item Name", "Bill Date", "Paymenttype"],
    ["Bill Number", "Billed Item Qty", "Billed Value"],
    ["Bill Passing Date", "Bill Type", ""],
  ];

  //
  const rows = [
    [returnData.IndentNumber, returnData.ponumber, returnData.POConsignee],
    [returnData.POItemName, returnData.billdate, returnData.paymentDesription],
    [returnData.billnumber, returnData.billitemQty, returnData.billitemValue],
    [returnData.billpassingdate, returnData.gemtype===1?'Gem Bill':'IREPS Bill', ""],
  ];


  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };
 



  return (
  <Box
    className="account-pending-page"
    sx={{
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      boxSizing: "border-box",
      px: { xs: 0.75, sm: 1.25, md: 2 },
      py: { xs: 0.75, sm: 1, md: 1.5 },
      overflowX: "hidden",
    }}
  >
    <Card
      className="account-pending-card"
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        overflow: "hidden",
        borderRadius: { xs: 2, md: 3 },
        border: "1px solid #dbe5f1",
        background: "#fff",
        boxShadow: "0 8px 28px rgba(13, 71, 161, 0.10)",
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          background:
            "linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%)",
          color: "#fff",
          px: { xs: 1.5, sm: 2, md: 2.5 },
          py: { xs: 1.3, sm: 1.5, md: 1.7 },
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "1rem",
              sm: "1.1rem",
              md: "1.25rem",
            },
            fontWeight: 700,
            lineHeight: 1.3,
          }}
        >
          CRN Entry
        </Typography>
      </Box>

      <CardContent
        sx={{
          p: { xs: 1, sm: 1.5, md: 2 },
          "&:last-child": {
            pb: { xs: 1.5, sm: 2, md: 2.5 },
          },
        }}
      >
        {/* PO DETAILS */}
        <Accordion
          defaultExpanded
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            mb: { xs: 1.5, md: 2 },
            border: "1px solid #dbe5f1",
            borderRadius: "10px !important",
            overflow: "hidden",
            boxShadow: "none",

            "&:before": {
              display: "none",
            },
          }}
        >
          <AccordionSummary
            expandIcon={
              <ArrowDownwardIcon
                sx={{
                  color: "#fff",
                  fontSize: { xs: 20, md: 24 },
                }}
              />
            }
            sx={{
              minHeight: { xs: 48, sm: 52 },
              px: { xs: 1.5, sm: 2 },
              background:
                "linear-gradient(135deg, #1565C0 0%, #1976D2 100%)",
              color: "#fff",

              "& .MuiAccordionSummary-content": {
                my: { xs: 1, sm: 1.2 },
              },

              "&.Mui-expanded": {
                minHeight: { xs: 48, sm: 52 },
              },
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "0.9rem",
                  sm: "1rem",
                  md: "1.05rem",
                },
                fontWeight: 700,
              }}
            >
              PO Details
            </Typography>
          </AccordionSummary>

          <AccordionDetails
            sx={{
              p: { xs: 0.75, sm: 1, md: 1.5 },
              background: "#f8fbff",
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              boxSizing: "border-box",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                overflow: "hidden",
              }}
            >
              <ListHeaderTableComponent
                headers={headers}
                rows={rows}
              />
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* CRN ENTRY SECTION */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            boxSizing: "border-box",
            border: "1px solid #dbe5f1",
            borderRadius: 2,
            background: "#fff",
            p: { xs: 1.25, sm: 1.5, md: 2 },
            mb: { xs: 1.5, md: 2 },
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: "0.9rem",
                sm: "0.95rem",
                md: "1rem",
              },
              fontWeight: 700,
              color: "#0D47A1",
              mb: { xs: 1.25, sm: 1.5 },
              pl: 1,
              borderLeft: "4px solid #1976D2",
              lineHeight: 1.4,
            }}
          >
            CRN Information
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "1fr 1fr",
              },
              gap: { xs: 1.5, sm: 2, md: 2.5 },
              width: "100%",
              minWidth: 0,
            }}
          >
            {/* CRN NUMBER */}
            <Box
              sx={{
                width: "100%",
                minWidth: 0,
              }}
            >
              <CustomTextField
                label="CRN Number"
                value={crnNumber ?? ""}
                onChange={(e) => {
                  setcrnNumber(e.target.value);
                }}
                placeholder="CRN Number"
                maxLength={50}
                error={!!errors.errCRN}
                helperText={errors.errCRN}
              />
            </Box>

            {/* CRN DATE */}
            <Box
              sx={{
                width: "100%",
                minWidth: 0,
              }}
            >
              <DatePickerComponent
                label="Date of CRN"
                id="crndate"
                value={crnDate}
                onChange={(newDate) =>
                  handleDateChange(
                    newDate,
                    setcrnDate
                  )
                }
                error={errors.crnDateerror}
                maxDate={today}
                minDate={
                  returnData.gemtype === 0
                    ? returnData.billpassingdate
                      ? dayjs(returnData.billpassingdate)
                      : dayjs()
                    : returnData.billdate
                    ? dayjs(returnData.billdate)
                    : dayjs()
                }
              />
            </Box>

            {/* ACCOUNT ENTRY DATE */}
            <Box
              sx={{
                width: "100%",
                minWidth: 0,
                gridColumn: {
                  xs: "auto",
                  sm: "1 / -1",
                },
              }}
            >
              <DatePickerComponent
                label="Hardcopy of Bill Sent to Account Date"
                id="accountyReceiptDate"
                value={accountEntryDate}
                onChange={(newDate) =>
                  handleDateChange(
                    newDate,
                    setaccountEntryDate
                  )
                }
                error={errors.sentdateerror}
                maxDate={today}
                minDate={
                  returnData.billpassingdate
                    ? dayjs(returnData.billpassingdate)
                    : dayjs()
                }
              />
            </Box>
          </Box>
        </Box>

        {/* ACTION BUTTONS */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
            },
            gap: { xs: 1, sm: 1.5, md: 2 },
          }}
        >
          {/* SAVE */}
          <button
            type="button"
            onClick={InsertPOData}
            title="Click for Data Save"
            className="account-action-btn account-save-btn"
          >
            Save Data
          </button>

          {/* CLOSE */}
          <button
            type="button"
            onClick={handleClose}
            title="Close"
            className="account-action-btn account-close-btn"
          >
            Close
          </button>
        </Box>
      </CardContent>
    </Card>

    {/* RESPONSIVE THEME */}
    <style>{`
      .account-pending-page,
      .account-pending-page * {
        box-sizing: border-box;
      }

      .account-pending-page {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        overflow-x: hidden;
      }

      .account-pending-card {
        width: 100%;
        max-width: 100%;
        min-width: 0;
      }

      /* ==============================
         TABLE RESPONSIVE FIX
         ============================== */

      .account-pending-card table {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        table-layout: fixed !important;
      }

      .account-pending-card th,
      .account-pending-card td {
        white-space: normal !important;
        overflow-wrap: anywhere !important;
        word-break: break-word !important;
        max-width: 0;
      }

      /* ==============================
         FORM FIELD WIDTH
         ============================== */

      .account-pending-card .MuiFormControl-root,
      .account-pending-card .MuiTextField-root {
        width: 100%;
        max-width: 100%;
        min-width: 0;
      }

      /* ==============================
         BUTTONS
         ============================== */

      .account-action-btn {
        width: 100%;
        min-height: 44px;
        border: none;
        border-radius: 8px;
        padding: 10px 16px;
        color: #fff;
        font-size: 0.9rem;
        font-weight: 700;
        cursor: pointer;
        transition:
          transform 0.18s ease,
          box-shadow 0.18s ease;
      }

      .account-save-btn {
        background:
          linear-gradient(
            135deg,
            #1565C0 0%,
            #1976D2 100%
          );

        box-shadow:
          0 4px 12px rgba(21, 101, 192, 0.25);
      }

      .account-close-btn {
        background:
          linear-gradient(
            135deg,
            #c62828 0%,
            #e53935 100%
          );

        box-shadow:
          0 4px 12px rgba(198, 40, 40, 0.20);
      }

      .account-action-btn:hover {
        transform: translateY(-1px);
      }

      .account-action-btn:active {
        transform: translateY(0);
      }

      /* ==============================
         TABLET
         ============================== */

      @media (max-width: 900px) {
        .account-pending-card th,
        .account-pending-card td {
          font-size: 0.78rem !important;
          padding: 7px 5px !important;
        }
      }

      /* ==============================
         MOBILE
         ============================== */

      @media (max-width: 600px) {
        .account-pending-page {
          padding-left: 4px !important;
          padding-right: 4px !important;
        }

        .account-pending-card {
          border-radius: 10px !important;
        }

        .account-pending-card th,
        .account-pending-card td {
          font-size: 0.72rem !important;
          padding: 6px 4px !important;
        }

        .account-action-btn {
          min-height: 42px;
          font-size: 0.85rem;
        }
      }

      /* ==============================
         SMALL MOBILE
         ============================== */

      @media (max-width: 400px) {
        .account-pending-card th,
        .account-pending-card td {
          font-size: 0.67rem !important;
          padding: 5px 3px !important;
        }

        .account-action-btn {
          min-height: 40px;
          font-size: 0.82rem;
        }
      }
    `}</style>
  </Box>
);
}

export default AccountPendingEntry;
